import { Col, Form, Row, Select, Input } from "antd";
import { useEffect, useRef, useState } from "react";
import { SALES_CONTRACT_LIST } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import HandleNotification from "../../Notification";
import { isArrayAndHasValue } from "../../../utils/functions";

const CostEstimateFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const form = Form.useFormInstance();
  const [salesContractList, setSalesContractList] = useState(null);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const mountedRef = useRef(true);
  const reqIdRef = useRef(0);
  const didSeedDefaultRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const getAllSalesContract = async (filterValues) => {
    const myReq = ++reqIdRef.current;
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      // Round 2 (B, R3): SalesContractController@index now honours this (backward
      // compatible; default unchanged) so the first row is the most recently
      // updated contract instead of the highest id.
      // ux2(final-2): renamed sort/order -> order_by/order_dir (whole-branch review I-2 —
      // sort/order collided with the Kyslik sortable() trait's own request('sort')/request('direction')).
      order_by: "updated_at",
      order_dir: "desc",
      ...filterValues,
    };
    const query = `${SALES_CONTRACT_LIST}`;
    const response = await getData(query, false, bodyData);

    if (!mountedRef.current || myReq !== reqIdRef.current) return;

    if (response && response?.data?.code === 200) {
      setSalesContractList(response?.data?.data?.data);
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        "Error in fetching Sales Contract List",
        null,
      );
    }
    setHasLoadedOnce(true);
  };

  useEffect(() => {
    getAllSalesContract();
  }, []);

  // Round 2 (B, R3): pre-select the most recently updated sales contract (already
  // sorted by the backend) and load its cost-estimate list once, through the form's
  // own submit path (fetchCostList in Account/CostEstimate/index.js), the same as a
  // manual Search would.
  useEffect(() => {
    if (didSeedDefaultRef.current) return;
    if (!hasLoadedOnce) return;
    didSeedDefaultRef.current = true;
    if (!isArrayAndHasValue(salesContractList)) return;

    const defaultId = salesContractList[0]?.id;
    if (!defaultId) return;

    form?.setFieldsValue({ sales_contract_id: defaultId });
    form?.submit();
  }, [hasLoadedOnce, salesContractList, form]);

  return (
    <>
      <Col className="gutter-row" span={4}>
        <Form.Item
          label="Sales Contract"
          name="sales_contract_id"
          rules={[
            {
              required: true,
              message: "Please Select Sales Contract No!",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select a Sales Contract No"
            optionFilterProp="children"
            onSearch={(value) => {
              getAllSalesContract({ reference_no: value });
            }}
            size="small"
            notFoundContent={
              hasLoadedOnce ? "No sales contracts found to pre-select." : undefined
            }
          >
            {isArrayAndHasValue(salesContractList) &&
              salesContractList?.map((item, index) => (
                <Option value={item?.id} key={item?.id}>
                  {item.reference_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default CostEstimateFilterFields;
